export function getEmailContent(type, data) {
    if (type === 'orgMemberInvite') {
        return {
            "to": [{"email": data.email}],
            // "bcc": emailArr,
            "subject": `You've been added to the ${data.orgName} organization on Gamably!`,
            "body": `
            <p>Hello!</p>
            <p>${data.managerName} has invited you to join the ${data.orgName} organization in Gamably, 
            the online gamification platform built specifically for super fun folks like you!</p>
            <p>Going forward, you will have access to ALL of the features Gamably offers. 
            Plus you will have access to media and game content created and shared by other members of your organization. 
            You will also be able to add other members of your organization as managers or distributors on games you create. 
            Click "Get Started" below to sign in or create your account!</p>
            `,
            "title": `Welcome to the fun! You have been added to the Gamably organization <b>${data.orgName}</b>!`,
            "templateId": "d-e0595a87b5764651848ef3cfc41c36cd",
            "buttonText": "Get Started",
            "headImage": `<img style='height: 60px; width: 60px; margin-right: 20px;' src='${data.orgIcon}' />`
        };
    }
    if (type === 'gameManagerInvite') {
        return {
            "to": [{"email": data.email}],
            // "bcc": emailArr,
            "subject": `You've been invited to help manage the ${data.gameName} game on Gamably!`,
            "body": `<p>Hello ${data.userName}!</p>
            <p>You've been added as a ${data.role} for the Gamably game: <b>${data.gameName}</b> 
            by ${data.managerName}. This gives you access to the game and its content and allows you to ${
                data.role === 'manager' 
                ? 'manage players and teams, create and edit game elements, distribute rewards, and more.' 
                : 'view players, and distribute rewards.'
            }</p>
            <p>To access the game, please log in to your Gamably account at <a href="https://gamably.com">gamably.com</a> 
            and navigate to your "My Games" dashboard. From there, you'll see "${data.gameName}" listed, 
            and you can begin managing or distributing the game as needed.</p>
            <p>Thank you for being a part of the Gamably community!</p>`,
            "title": `Welcome to the fun! You have been added to the Gamably organization <b>${data.gameName}</b>!`,
            "templateId": "d-e0595a87b5764651848ef3cfc41c36cd",
            "buttonText": "Get Started",
            "headImage": `<img style="height: 60px; width: 60px; margin-right: 20px;" src="${data.gameIcon}" />`
        };
    }
}